export const breakpointPxValues = [768, 992, 1200];
export const breakpointsPx = breakpointPxValues.map((bp: any) => `${bp}px`);
export const breakpoints = breakpointPxValues.map((bp: any) => `${bp / 16}em`);

export default breakpoints;
